module.exports = __webpack_public_path__ + "static/faerie_dragon_light_blue-cbf947bbd40f69a887167c3d71166727.jpg";